import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { PortfolioMovementType, EnrollmentStatus } from './portfolio-movement.service';

export interface PunishedPortfolioReportItem {
  nemonico: string;
  proyecto: string;
  tipoInscripcion: string;
  idInscripcion: number;
  tipoPagador: string;
  nombrePagador: string;
  tipoDocumento: string;
  numeroDocumento: string;
  emailPagador: string;
  telefonoPagador: string;
  numeroCuota: number;
  fechaVencimiento: Date;
  moneda: string;
  montoAPagar: number;
  montoPagado: number;
  saldoPendiente: number;
  estadoPago: string;
  tipoMovimiento: PortfolioMovementType;
  tipoMovimientoDescripcion: string;
  fechaMovimiento?: Date;
  razonCastigo: string;
  estadoInscripcion: EnrollmentStatus;
  estadoInscripcionDescripcion: string;
}

@Injectable({
  providedIn: 'root'
})
export class PunishedPortfolioReportService {
  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "PunishedPortfolioReport";
  }

  // Obtener datos del reporte de cartera castigada
  getReport(startDate?: Date, endDate?: Date, projectId?: number, participantId?: number, companyId?: number): Observable<any> {
    let params = new HttpParams();
    if (startDate) params = params.set('startDate', startDate.toISOString());
    if (endDate) params = params.set('endDate', endDate.toISOString());
    if (projectId) params = params.set('projectId', projectId.toString());
    if (participantId) params = params.set('participantId', participantId.toString());
    if (companyId) params = params.set('companyId', companyId.toString());

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}`, { params })
      .pipe(catchError(this.handleErrors));
  }

  // Descargar Excel del reporte de cartera castigada
  downloadExcel(startDate?: Date, endDate?: Date, projectId?: number, participantId?: number, companyId?: number): Observable<Blob> {
    let params = new HttpParams();
    if (startDate) params = params.set('startDate', startDate.toISOString());
    if (endDate) params = params.set('endDate', endDate.toISOString());
    if (projectId) params = params.set('projectId', projectId.toString());
    if (participantId) params = params.set('participantId', participantId.toString());
    if (companyId) params = params.set('companyId', companyId.toString());

    return this._http.get(`${this._baseUrl}/${this._controllerName}/excel`, {
      params,
      responseType: 'blob'
    }).pipe(catchError(this.handleErrors));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrió un error", error.error.message);
    } else {
      console.log(`Ocurrió un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
